export class Position {
    id = 0;
    name = "";
    isChecked = false;
}
export class HasonInfo {
    sKeiyakuKb = 0;
    hasonList = [];
    isNothing = false;
    remarks = "";
    hasInvalidCharError = false;
}
